
import React, { Component } from 'react';
import './styles/player-controls-vod.css';
import TimeLabel from './common/TimeLabel';
import PlayerSlider from './common/PlayerSlider';
import VideoPlayerControl from './../components/common/VideoPlayerControl';
import {
    CONTROL_BACKWARD,
    CONTROL_FORWARD,
    CONTROL_PLAY,
    CONTROL_PAUSE,
    CONTROL_LANGUAGE,
    CONTROL_SERIE,
    CONTROL_FAVORITE,
    CONTROL_UNFAVORITE
} from './common/constants';
import { setSeekInterval } from './seekIntervalUtil';
import TrackerManager from '../../utils/TrackerManager';
import PlayerControlsLogic from './PlayerControlsLogic';
import { AAF_CONTENT_IS_VOD } from './../../AAFPlayer/constants';
import Utils from '../../utils/Utils';
import { playerSettings } from './common/constants';
import Translator from '../../requests/apa/Translator';
import VODInfoLabel from './common/VODInfoLabel';
import { setEventData } from '../../components/Modal/ModalTimeOutEvent'
import settings from '../../devices/all/settings';
import { Grid, Row, Column, cls } from '../../packages/components';
import { fetchFavoriteLoader} from '../../requests/loader';
import store from '../../store';
import favoriteDelTask from '../../requests/tasks/ficha/favoriteDelTask';
import favoriteTask from '../../requests/tasks/ficha/favoriteTask';
import RequestManager from '../../requests/RequestManager';
import UpdateFavoriteVODObserver from '../../AAFPlayer/helpers/UpdateFavoriteVODObserver'
import { setLastTouchFavorited, setLastTouchSeen } from './../../reducers/user';
import { updateValuesStorageMount,
  updateValuesStorageUnMount } from 'src/components/Modal/functions/ModalInactivity/index'
class PlayerControlsVod extends Component {

    constructor(props) {
        super(props);

        this.backward = this.backward.bind(this);
        this.forward = this.forward.bind(this);
        this.play = this.play.bind(this);
        this.pause = this.pause.bind(this);
        this.onLanguage = this.onLanguage.bind(this);
        this.onSerie = this.onSerie.bind(this);

        this.defaultButtons = [
            { type: CONTROL_BACKWARD, clic: this.backward, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_rewind', 'Atrasar') },
            { type: CONTROL_PLAY, clic: this.play, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_play', 'Reproducir') },
            { type: CONTROL_FORWARD, clic: this.forward, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_forward', 'Adelantar') },
            { type: CONTROL_LANGUAGE, clic: this.onLanguage, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_language', 'Idioma') },
        ];
        this.addEventListeners = this.addEventListeners.bind(this);
        this.removeEventListeners = this.removeEventListeners.bind(this);
        this.slide = this.slide.bind(this);
        this.updateCurrentTimeUI = this.updateCurrentTimeUI.bind(this);
        this.updateCurrentTime = this.updateCurrentTime.bind(this);
        this.sendFowardRewindSeek = this.sendFowardRewindSeek.bind(this);
        this.showSprites = this.showSprites.bind(this);
        this.hideSprites = this.hideSprites.bind(this);
        this.handleEndPlayer = this.handleEndPlayer.bind(this);
        this.toggleFavorite = this.toggleFavorite.bind(this);
        this.getVisibleButtons = this.getVisibleButtons.bind(this);
        this.setContentTitle = this.setContentTitle.bind(this);
        this.checkFavoritedContent = this.checkFavoritedContent.bind(this);

        this.seekInPause = 0;
        this.seekTime = 0;
        this.isMoving = false;
        this.seekTotalTime = 0;
        this.currentTime = 0;
        this.data = {};

        this.timeoutTitleId = null;
        this.timeoutTitleMs = 3000;

        this.state = {
            serieData: null,
            isFavorite: false,
        };

        this.paramsModalSleep = {
          pause: this.pause,
          play: this.play,
          exit: this.props.onExit,
        };
        this.isSerie = store.getState().modalInactivity.isSerie;
        this.isPlaying = store.getState().player.playerstate === "PLAYING"
        this.setIntervalModalInactivity = this.isPlaying ? PlayerControlsLogic.setIntervalModalReproduction(this.paramsModalSleep) :null;

        const that = this;
        this.seekBarInterval = setSeekInterval(function () {
            if (that.seekTotalTime >= 0 && that.isMoving) {
                console.log('[NPC] interval seek', that.seekTotalTime);
                //Send stats related to seek (i.e. sumologic)
                that.sendFowardRewindSeek();
                that.seek(that.seekTotalTime);
                that.seekTotalTime = 0;
                that.seekTime = 0;
                that.isMoving = false;
                that.props.onIsMoving(false);
                // that.setTimer();
            }
            console.log('[PlayerControls] interval before stop after set seek ');
            this.stop();
        }, 2);
    }

    onLanguage() {
        this.props.onLanguage({
            title: this.data && this.data.contentTitleNormal || '',
            contentSerieEpisodeTitle: this.data && this.data.contentSerieEpisodeTitle || null,
            description: this.data && this.data.description || '',
            duration: this.data && this.data.duration || null
        });
    }

    updateCurrentTime(currentTime) {
        this.setCurrentTime(currentTime);
        if (!this.isMoving) {
            this.updateCurrentTimeUI(currentTime);
        }
    }

    setCurrentTime(currentTime) {
        this.currentTime = currentTime;
    }

    getCurrentTime() {
        return this.currentTime;
    }

    getDuration() {
        return this.props.getDuration();
    }

    getBallPosition(ballPercent) {
        if (this.refs['playerSlider']) {
            const width = this.refs['playerSlider'].refs['barContainer'].offsetWidth;
            if (width < 1) return 0;
            const left = (width * ballPercent) / 100;

            return left;
        }

        return 0;
    }

    updateCurrentTimeUI(currentTime) {
        const ballPercent = PlayerControlsLogic.getPercentProgress(currentTime, this.getDuration());
        if (this.refs['playerSlider']) {
            // % barra avance
            this.refs['playerSlider'].refs['progressNow'].style.width = ballPercent + '%';
            // Time start
            this.refs['timeStart'].refs['time'].innerHTML = PlayerControlsLogic.getContentDuration(currentTime, AAF_CONTENT_IS_VOD);
            // Ball position
            this.refs['playerSlider'].refs['ball'].style.left = this.getBallPosition(ballPercent) + 'px';
            // Time end
            // console.log('[NPC] PlayerControls this.refs[playerControls].refs[timeEnd].refs[time].innerHTML', this.refs['playerControls'].refs['timeEnd'].refs['time'].innerHTML);
            this.refs['timeEnd'].refs['time'].innerHTML = PlayerControlsLogic.getContentDuration(this.getDuration(), AAF_CONTENT_IS_VOD);
            // this.props.contentSprite && this.props.updateCurrentTimeSprite(currentTime);
            this.props.contentSprite && this.props.updateSpritePosition();
        }
    }

    sendFowardRewindSeek() {
        console.log('[NPC] SEND STATS SEEK');
        const { isBackward, seekTime } = this.getOperatorsSeek();

        if (isBackward && (seekTime === 15 || seekTime === 10)) {
            TrackerManager.rewind(this.getCurrentTime());
        } else if (!isBackward && (seekTime === 15 || seekTime === 10)) {
            TrackerManager.foward(this.getCurrentTime());
        }
    }

    /**
     * Resolve enabled buttons
     */
    getVisibleButtons() {
        const user = store.getState().user;
        const { ispreview } = this.props;
        const visible = this.defaultButtons.map(
            (button) => {
                if (button.type === CONTROL_PLAY) {
                    if (this.props.playing) {
                        return { type: CONTROL_PAUSE, clic: this.pause, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_pause', 'Pausa') };
                    }
                    else {
                        // Por default el botón es play
                        return button;
                    }
                }
                else
                    return button;
            }
        );

        const followText = Translator.get('playing_playerControls_toolbar_button_addList', 'Agregar a Mi Lista');
        const unfollowText = Translator.get('playing_playerControls_toolbar_button_deleteList', 'Quitar de Mi Lista');

        const isSerie = this.state.serieData && !ispreview;

        if (!user.isAnonymous && !isSerie) {
            visible.push({ type: this.state.isFavorite ? CONTROL_UNFAVORITE : CONTROL_FAVORITE, clic: this.state.isFavorite ? this.deleteFavorite : this.addToFavorite, enabled: true, title: this.state.isFavorite ? unfollowText : followText })
        }

        if (isSerie) {
            visible.push({ type: CONTROL_SERIE, clic: this.onSerie, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_seasons', 'Temporadas') });
            visible.push({ type: this.state.isFavorite ? CONTROL_UNFAVORITE : CONTROL_FAVORITE, clic: this.state.isFavorite ? this.deleteFavorite : this.addToFavorite, enabled: true, title: this.state.isFavorite ? unfollowText : followText })
        }

        return visible;
    }

    onSerie() {
        const { group_id = null, contentTitleNormal = '' } = this.data;
        this.props.onSerie(group_id, contentTitleNormal);
    }

    addEventListeners() {
        this.removeEventListeners();
        document.addEventListener(settings.end_vod_fire_event, this.handleEndPlayer);
    }

    removeEventListeners() {
        document.removeEventListener(settings.end_vod_fire_event, this.handleEndPlayer);
    }

    handleEndPlayer() {
        this.props.hideAll();
    }

    /**
   * Slider side actions
   * @param e
   */
    slide(e) {
        console.log('[NPC] Playercontrols slide events');
        if (!this.props.enabled) return;

        // Reset autohide
        this.props.onSlide(null, direction);

        const { direction } = e.detail;
        switch (direction) {
            case 'left':
                e.preventDefault();
                this.calculateFinalSeekTime(true, playerSettings.slideTime);
                break;
            case 'right':
                e.preventDefault();
                this.calculateFinalSeekTime(false, playerSettings.slideTime);
                break;
            default:
                break;
        }
    }

    forward() {
        if (!this.props.enabled) return;
        this.props.onForward(null);
        this.calculateFinalSeekTime(false, playerSettings.forwardTime);
    }

    backward() {
        if (!this.props.enabled) return;
        this.props.onBackward(null);
        this.calculateFinalSeekTime(true, playerSettings.backwardTime);
    }

    /**
    * Controles del player
    */
    play() {
        if (!this.props.enabled) return;
        try {
            this.props.play(); // Play player device
            this.props.onPlay(() => {
                if (this.props.visible) this.props.focus('.video-player-control-main-button-pause');
                if (this.seekInPause) {
                    Utils.seekInPause(this.props.seek, this.seekInPause);
                    this.seekInPause = 0;
                }
            });
            if (Utils.isTimeoutAvailable()) {
                const { clearTimeOutAAF = () => { } } = this.props;
                clearTimeOutAAF();
            }
        } catch (err) {
            console.error('[ playercontrols - error on play ] ',err)
        }

    }

    pause() {
        if (!this.props.enabled) return;
        try {
            this.props.pause();
            this.props.onPause(this.getCurrentTime(), () => {
                this.props.focus('.video-player-control-main-button-play');
            });
            if (Utils.isTimeoutAvailable()) {
                const { startTimeOutAAF = () => { } } = this.props;
                startTimeOutAAF();
            }
        } catch (err) {
            console.error('[ playercontrols - error on pause ] ',err)
        }
    }

    async checkFavoritedContent(groupId) {
        const user = store.getState().user;
        const filterList = Utils.getAPAFilterList();
        const favs = await fetchFavoriteLoader(user, filterList);
        if (
          favs &&
          favs.response &&
          favs.response &&
          favs.response.groups &&
          Array.isArray(favs.response.groups)
        ) {
          const favoritedContent = favs.response.groups.find(el => el.id == groupId);
          this.setState({isFavorite: favoritedContent && typeof favoritedContent == 'object'});
        }
        return new Promise(resolve => resolve(true));
    };

    deleteFavorite = event => {
        event.preventDefault();
        const user = store.getState().user;
        const p = {
          object_id: this.data.group_id,
          object_type: 1,
          user_hash: user ? user.session_userhash : null
        };
        const params = new favoriteDelTask(p);
        RequestManager.addRequest(params)
          .then(data => {
            this.toggleFavorite(false);
            const responseData = data.data;
            if (responseData && responseData.delete) {
              // Actualizar favoritos y seen con el mismo valor de favorited (para que lo tome level-user)
              if (responseData.lasttouch && responseData.lasttouch.favorited) {
                const lastTouchFav = responseData.lasttouch.favorited;
                store.dispatch(setLastTouchSeen(lastTouchFav));
                store.dispatch(setLastTouchFavorited(lastTouchFav));
              }
            }
          })
          .catch(e => {
            console.error(e);
          });
      };

    addToFavorite = event => {
        event.preventDefault();
        const user = store.getState().user;
        const p = {
            object_id: this.data.group_id,
            object_type: 1,
            user_hash: user.session_userhash
        };

        const params = new favoriteTask(p);
        RequestManager.addRequest(params).then(data => {
            this.toggleFavorite(true);

            // Actualizar favoritos y seen con el mismo valor de favorited
            if (data.lasttouch && data.lasttouch.favorited) {
                const lastTouchFav = data.lasttouch.favorited;
                store.dispatch(setLastTouchSeen(lastTouchFav));
                store.dispatch(setLastTouchFavorited(lastTouchFav));
            }
        })
        .catch(e => {
            console.error(e);
        });
    };

    toggleFavorite(isFavorite) {
        this.setState({ isFavorite })
        UpdateFavoriteVODObserver.emit("favorite", {isFavorite, groupId: this.data.group_id});
    }
    /**
    *
    */

    focusPlayPauseButton(btnClass) {
        this.props.focus(btnClass);
    }

    showSprites() {
        if (!this.props.contentSprite) return;
        if (this.timeoutTitleId) {
            clearTimeout(this.timeoutTitleId);
            this.timeoutTitleId = null;
        }
        this.setContentTitle({ title: '&nbsp;' }, false);
        this.props.showSprites(this.props.canShowSprites());
    }

    hideSprites() {
        if (!this.props.contentSprite) return;
        this.props.hideSprites()
        this.timeoutTitleId = setTimeout((() => {
            this.setContentTitle(this.data, false);
        }), this.timeoutTitleMs);
    }

    calculateFinalSeekTime(isBackward, seekTime) {
        if (!this.props.enabled) return;

        const spritesEnabled = this.props.contentSprite;
        if (spritesEnabled) {
            this.showSprites();
        }

        // TODO this.showSprites(this.canShowSprites());
        console.log(
            '[NPC] Vemos los nuevos tiempos que se tienen en el player  -isBackward - seekTime ',
            isBackward,
            seekTime
        );
        this.setOperatorsSeek({ isBackward, seekTime });
        // TODO Esto de abajo se debe hacer desde el class father para que muestre la barra
        // TODO this.show();
        let secs = isBackward ? -seekTime : seekTime;
        let curTime = this.getCurrentTime();
        if (this.seekInPause) {
            curTime = this.seekInPause;
        }
        let newSecs = curTime + (this.seekTime += secs);
        if (newSecs < 0) {
            newSecs = 0;
        }
        if (newSecs > this.getDuration()) {
            newSecs = this.getDuration() - 1;
        }
        console.log(
            '[NPC] calculateFinalSeekTime',
            '\nisBackward ' + isBackward,
            '\nnewSeekTime ' + seekTime,
            '\nseekTime ' + this.seekTime,
            '\nnewSecs ' + newSecs,
            '\ncurTime ' + curTime,
            '\nspritesEnabled ' + spritesEnabled,
        );
        this.updateCurrentTimeUI(newSecs);
        spritesEnabled && this.props.updateSprite(newSecs);
        this.doSeek(newSecs, curTime);
        spritesEnabled && this.hideSprites();
    }

    doSeek(newSecs, currentTime) {
        console.log(
            '[NPC] doSeek  ' + '-newSecs ' + newSecs,
            '- currentTime ' + currentTime
        );
        this.seekBarInterval.stop();
        this.seekBarInterval.start();
        this.isMoving = true;
        this.props.onIsMoving(true);
        this.seekTotalTime = newSecs;
    }

    seek(time) {
        /**
         * De acuerdo a este commit https://bitbucket.org/dlaargentina/stvreact/commits/9c72921b8d5978e76ad2046d184004a0da4c2122
         * si el player está en currenttime 0, se oculta playerControls (this.hide() y se pone la bandera this.isVisible = false).
         *
         * Pero esto de arriba no permite que se haga un seek a 0 en los primeros 29 segundos de reproducción
         * porque al hacer el seek al time=0 la bandera isVisible ya está en false, por tanto el seek no lo hace.
         * Se agrega validación extra para forzar seek en 0 (con doSeek var de abajo)
         */
        let doSeek = this.props.visible;
        if (time < 1 && !this.props.visible) {
            doSeek = true;
        }

        if ((doSeek) && this.props.enabled) {
            if (!this.props.playing) {
                this.seekInPause = time;
                this.setCurrentTime(this.seekInPause);
            } else {
                this.props.seek(time);
            }
        }
    }

    setOperatorsSeek(values) {
        this.valuesSeek = { ...values };
    }

    getOperatorsSeek() {
        return this.valuesSeek;
    }

    async setContentTitle(contentTitle, saveData = true) {
        setEventData(contentTitle);

        if (this.refs['vodInfoLabel'] && contentTitle.title) {
            const data = { ...contentTitle };
            if (saveData) {
                this.checkFavoritedContent(contentTitle.group_id);
                this.data = contentTitle;
            }
            if (this.refs['vodInfoLabel'].refs['vodEventTitle']) this.refs['vodInfoLabel'].refs['vodEventTitle'].innerHTML = Utils.cutPlayerString(data.title, 70, 67);
        }
    }

    getDataContentTitle() {
        return this.data;
    }

    async componentWillReceiveProps(nextProps) {
      if(!this.setIntervalModalInactivity){
        await updateValuesStorageMount(AAF_CONTENT_IS_VOD)
        this.setIntervalModalInactivity = PlayerControlsLogic.setIntervalModalReproduction(this.paramsModalSleep)
      }
        this.setState({ serieData: nextProps.serieData });

        if (nextProps.serieData) {
          this.isSerie = true;
          PlayerControlsLogic.setValueStatePlaying({ isSerie: true});
        }else{
          this.isSerie = false;
          PlayerControlsLogic.setValueStatePlaying({ isSerie: false});
        }
    }

    async componentDidMount() {
        await updateValuesStorageMount(AAF_CONTENT_IS_VOD)
        this.addEventListeners();
    }

    componentWillUnmount() {
        clearInterval(this.setIntervalModalInactivity)
        !this.isSerie && updateValuesStorageUnMount(this.setIntervalModalInactivity)
        this.removeEventListeners();
    }

    render() {
        console.log('[NPC2] PC VOD render ');
        const visibleButtons = this.getVisibleButtons();

        let defLength = 3;
        let controlsClassName = '';
        if(Array.isArray(visibleButtons)) {
            defLength = visibleButtons.length;
            controlsClassName = `player-controls-width-${defLength}`;
        }

        let ct = 1;
        return (
            <div>
                <Grid className={cls(`player-controls-vod-container`)}>
                    <Row className={cls(`player-controls-vod-channelinfo-wrapper`)}>
                        <VODInfoLabel ref="vodInfoLabel" />
                    </Row>
                    <Row className={cls(`player-controls-vod-flex-slider-wrapper`)}>
                        <Column lg={1} className={cls(``)}>
                            <TimeLabel ref="timeStart" />
                        </Column>
                        {/* La barra Bar Total es la que muestra en un startover, la que muestra el progress del evento respecto al now.  */}
                        <Column lg={10} className={cls(``)}>
                            <PlayerSlider
                                ref="playerSlider"
                                withBarTotal={false}
                                slide={this.slide}
                                ballPercent={this.props.ballPercent}
                            />
                        </Column>
                        <Column lg={1} className={cls(``)}>
                            <TimeLabel customCss="time-label-custom-end" ref="timeEnd" />
                        </Column>
                    </Row>
                    <Row className={cls(``)}>
                        <div className="player-controls-vod-separator"></div>
                    </Row>
                </Grid>
                <Grid className={cls(`player-controls-vod-no-grid-float`)}>
                    <Row className={cls(`player-controls-vod-flex-controls-wrapper ${controlsClassName}`)}>
                        {
                            visibleButtons.map((button, idx, items) => <VideoPlayerControl
                                control={button}
                                onClic={button.clic}
                                key={`control_${ct++}`}
                                id={`pc${idx}`}
                                nav={this.props.getPlayerControlsButtonNavigation(idx, items, true)}
                            />
                            )
                        }
                    </Row>
                </Grid >
            </div>
        )
    }
}

export default PlayerControlsVod;



// WEBPACK FOOTER //
// ./src/playerDomain/components/PlayerControlsVod.js